import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { UserMood } from 'user/mood/user-mood';

export interface UserMoodDocument {
	readonly id: string;
	readonly mood: number;
	readonly feelings: string;
	readonly creationTimestamp: number;
}

export type UserMoodsState = EntityState<UserMoodDocument, string>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'userMoods' })
export class UserMoodsStore extends EntityStore<UserMoodsState> {
	constructor() {
		super();
	}

	public asDocument(userMood: UserMood): UserMoodDocument {
		return userMood
			? {
					id: userMood.id,
					mood: userMood.mood,
					feelings: userMood.feelings,
					creationTimestamp: userMood.creationTimestamp,
			  }
			: null;
	}

	public asEntity(document: UserMoodDocument): UserMood {
		return document
			? new UserMood(
					document.id,
					document.creationTimestamp,
					document.mood,
					document.feelings
			  )
			: null;
	}
}
